import { CloseIcon, IconButton, Theme, Typography, createStyles, makeStyles } from '@forgeglobal/design-framework'
import { OpportunityConversationsSidebarPanel } from 'components/shared/OpportunityConversationsSidebarPanel'
import { OpportunityFragment, TradeIntentType } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'
import moment from 'moment'

const useStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: spacing(2),
    },
    hidden: {
      opacity: 0,
    },
    title: {
      textAlign: 'center',
    },
  })
)

const OpportunityNotesSidebar: React.FC<{
  opportunity: OpportunityFragment
  setExpanded: (panel: boolean) => void
}> = ({ opportunity, setExpanded }) => {
  const classes = useStyles()

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => void 0

  const handleClick = () => {
    setExpanded(false)
  }

  return (
    <Fragment>
      <div className={classes.header}>
        <div className={classes.hidden}>
          <CloseIcon />
        </div>
        <div className={classes.title}>
          <Typography variant="h5">Opportunity Notes</Typography>
          <Typography variant="caption" color="textSecondary">{`${opportunity.company.name} ${
            opportunity.type === TradeIntentType.Bid ? 'Bid' : 'Ask'
          } | Renewed ${moment(opportunity.last_refreshed_at).format('MM/DD/YYYY')}`}</Typography>
        </div>
        <IconButton aria-label="close" onClick={handleClick}>
          <CloseIcon />
        </IconButton>
      </div>
      <OpportunityConversationsSidebarPanel
        onChange={handleChange('conversations')}
        opportunityId={opportunity.id}
        accountId={opportunity.account_id}
      />
    </Fragment>
  )
}

export { OpportunityNotesSidebar }
